import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from '@env/environment';
import { hmrBootstrap } from 'hmr';
import { Logger } from '@core/services/logger.service';
import { installAllPatches } from '@core/patches/installer';

if ( environment.production )
{
    enableProdMode();
    Logger.enableProductionMode();
}

// angular-auth-oidc-client caches the resolved discovery endpoints (issuer,
// authorization endpoint, …) in localStorage and reuses them instead of
// re-fetching. A cached entry written against a different Keycloak authority —
// e.g. the old `up2boat-dev` realm, still produced by any branch from before the
// realm switch — therefore keeps redirecting to that realm forever, no matter
// what the current build is configured with. Drop such entries on every start so
// switching branches (or changing the authority again) self-heals.
const configuredAuthority = stripTrailingSlash(environment.keycloakConfig.url);

for (const key of Object.keys(localStorage)) {
    const raw = localStorage.getItem(key);
    if (!raw || !raw.includes('authWellKnownEndPoints')) {
        continue;
    }
    try {
        const issuer = JSON.parse(raw)?.authWellKnownEndPoints?.issuer;
        if (issuer && stripTrailingSlash(issuer) !== configuredAuthority) {
            localStorage.removeItem(key);
        }
    } catch {
        // Not an OIDC config entry (or not JSON at all) — leave it untouched.
    }
}

function stripTrailingSlash(url: string): string {
    return url.replace(/\/+$/, '');
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule)
    .then(ref => {
        if (window['ngRef']) {
            window['ngRef'].destroy();
        }
        window['ngRef'] = ref;
        return ref;
    });

if ( environment.hmr )
{
    if ( module['hot'] )
    {
        hmrBootstrap(module, bootstrap);
    }
    else
    {
        console.error('HMR is not enabled for webpack-dev-server!');
        console.log('Are you using the --hmr flag for ng serve?');
    }
}
else
{
    bootstrap().catch(err => console.error(err));
}

installAllPatches();
